var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"id":_vm.poll.uid,"type":"number","value":_vm.results[_vm.questionnaireUid].answers[_vm.poll.uid].answer[0]}})}
var staticRenderFns = []

export { render, staticRenderFns }